export default [
  {
    path: '/personalInfo',
    name: 'personalInfo',
    component: () => import('@parent/views/home/child/personal-info.vue'),
  },
  {
    path: '/personalInfoEdit',
    name: 'personalInfoEdit',
    component: () => import('@parent/views/home/child/personal-edit.vue'),
  },
  {
    path: '/studentManagement',
    name: 'studentManagement',
    component: () => import('@parent/views/base/student-management/student-list.vue'),
  },
  {
    path: '/studentSelect',
    name: 'studentSelect',
    component: () => import('@parent/views/base/student-management/student-select.vue'),
  },
  {
    path: '/studentInfo',
    name: 'studentInfo',
    component: () => import('@parent/views/base/student-management/student-info.vue'),
  },
  {
    path: '/detail/:id',
    name: 'detail',
    component: () => import('@parent/views/mall/detail.vue'),
  },
  {
    path: '/mall/:id',
    name: 'mall',
    component: () => import('@parent/views/mall/list.vue'),
  },
  {
    path: '/classSchedule',
    name: 'classSchedule',
    component: () => import('@parent/views/base/schedule/index.vue'),
  },
  {
    path: '/baseClassCard',
    name: 'baseClassCard',
    component: () => import('@parent/views/base/classCard/class-card-detail.vue'),
  },
  // {
  //     path: "/baseClassInfos",
  //     name: "baseClassInfos",
  //     component: () => import("@parent/views/base/classCard/classInfos.vue"),
  // },
  {
    path: '/baseClassStatistics',
    name: 'baseClassStatistics',
    component: () => import('@parent/views/base/classCard/class-statistics.vue'),
  },
  // {
  //   path: '/browsingHistory',
  //   name: 'browsingHistory',
  //   component: () => import('@parent/views/home/child/browsing-history.vue'),
  // },
  // 没用到commentList页面
  // {
  //   path: '/commentList',
  //   name: 'commentList',
  //   component: () => import('@parent/views/base/comment/list.vue'),
  // },
  {
    path: '/commentDetail/:id',
    name: 'commentDetail',
    component: () => import('@parent/views/base/comment/detail.vue'),
  },
  {
    path: '/vSelectStudent',
    name: 'vSelectStudent',
    component: () => import('@parent/views/home/child/select-student.vue'),
  },
  {
    path: '/myStudents',
    name: 'myStudents',
    component: () => import('@parent/views/home/child/my-students.vue'),
  },
  {
    path: '/switchCompany',
    name: 'switchCompany',
    component: () => import('@parent/views/base/switch-company.vue'),
  },
  {
    path: '/parentForbid',
    name: 'parentForbid',
    component: () => import('@parent/views/base/parent-forbid.vue'),
  },
  {
    path: '/reserveList',
    name: 'reserveList',
    component: () => import('@parent/views/base/reserve/list.vue'),
  },
  {
    path: '/reserveLog',
    name: 'reserveLog',
    component: () => import('@parent/views/base/reserve/log.vue'),
  },
  {
    path: '/dynamicNoticeList',
    name: 'dynamicNoticeList',
    component: () => import('@parent/views/base/dynamic-notice/list.vue'),
  },
  {
    path: '/evaluation-detail/:id',
    name: 'evaluation-detail',
    component: () => import('@teacher/views/evaluation/detail.vue'),
  },
  {
    path: '/notice-list',
    name: 'notice-list',
    component: () => import('@parent/views/base/notice/list.vue'),
  },
  {
    path: '/notice-detail/:id',
    name: 'notice-detail',
    component: () => import('@parent/views/base/notice/detail.vue'),
  },
  {
    path: '/growup-record-detail/:id',
    name: 'growup-record-detail',
    component: () => import('@teacher/views/base/growup-record/detail.vue'),
  },
  {
    path: '/e-wallet',
    name: 'e-wallet',
    component: () => import('@parent/views/base/wallet/wallet.vue'),
  },
  {
    path: '/wallet-record/:id',
    name: 'wallet-record',
    component: () => import('@parent/views/base/wallet/wallet-record.vue'),
  },
  {
    path: '/cepingDetail/:id',
    name: 'cepingDetail',
    component: () => import('@parent/views/base/ceping/detail.vue'),
  },
];
